import React, { useState } from 'react';
import '../styles/DiceRoller.css';

function DiceRoller({ onRollComplete }) {
  const [rolling, setRolling] = useState(false);
  const [result, setResult] = useState(null);

  const rollDice = () => {
    setRolling(true);
    setResult(null);

    setTimeout(() => {
      const roll = Math.floor(Math.random() * 20) + 1; // d20 roll
      setResult(roll);
      setRolling(false);
      if (onRollComplete) onRollComplete(roll);
    }, 1500); // 1.5 seconds of animation
  };

  return (
    <div className="dice-roller">
      {rolling ? (
        <div className="dice rolling">🎲</div>
      ) : result !== null ? (
        <div className="dice result">{result}</div>
      ) : (
        <button onClick={rollDice} className="roll-button">Roll D20</button>
      )}
    </div>
  );
}

export default DiceRoller;
